<div>
  <h3>{{'changes_history'|translate}}</h3>
  <div>
    <s-table #table [cols]="cols" [refreshUrl]="refreshUrl" [resizable]="false" (onRowsRaw)="onRowsRaw($event)"
      [params]="params" [hideRows]="true" [hidePaginator]="true">
      <ng-template let-row let-rowRaw="raw" let-index="index" #slotRow>
        <tr>
          <td style="width: 1%"></td>
          <ng-container *ngFor="let col of cols">
            <td [style]="col.tdStyle">
              <pre *ngIf="col.type == 'json_viewer' else static" class="json-preview">{{ row[col.attr] | json }}</pre>
              <ng-template #static>{{row[col.attr]}}</ng-template>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </s-table>
  </div>
</div>
